import { render, staticRenderFns } from "./EmailCollector.vue?vue&type=template&id=4a9ae214"
import script from "./EmailCollector.vue?vue&type=script&lang=js"
export * from "./EmailCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports